import React, { Component } from "react";


// @mui material components
import Grid from "@mui/material/Grid";

// Dashboard React components
import DSBox from "components/DSBox";

// Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Timeline page components
import TimeLine from "react-gantt-timeline";
import Generator from './Generator';

const config = {
  header: {
    top: {//Tartget the month elements
      style: { backgroundColor: "#344767" } //The style applied to the month elements
    },
    middle: {//Tartget elements displaying the day of week info
      style: { backgroundColor: "#0A0A67" }, //The style applied to the day of week elements
      selectedStyle: { backgroundColor: "#b13525" }//The style applied to the day of week elements when is selected
    },
    bottom: {//Tartget elements displaying the day number or time 
      style: { background: "grey", fontSize: 9 },//the style tp be applied 
      selectedStyle: { backgroundColor: "#b13525", fontWeight: 'bold' }//the style tp be applied  when selected
    },
    month: {
      dateFormat: 'MMMM  YYYY',
      style: {
        background: 'linear-gradient( grey, black)',
        textShadow: '0.5px 0.5px black',
        fontSize: 12
      }
    },
    dayOfWeek: {
      style: {
        background: 'linear-gradient( orange, grey)',
        fontSize: 9
      }
    },
    dayTime: {
      style: {
        background: 'linear-gradient( grey, black)',
        fontSize: 9,
        color: 'orange'
      },
      selectedStyle: {
        background: 'linear-gradient( #d011dd ,#d011dd)',
        fontWeight: 'bold',
        color: 'white'
      }
    }
  },
  taskList: {
    title: {
      label: 'Tasks',
      style: {
        //background: '#0A0A67'
      }
    },
    task: {
      style: {
        backgroundColor: 'grey',
        color: 'white'
      }
    },
    verticalSeparator: {
      style: {
        backgroundColor: '#fbf9f9'
      },
      grip: {
        style: {
          backgroundColor: 'blue'
        }
      }
    }
  },
  dataViewPort: {
    rows: {
      style: {
        backgroundColor: 'white',
        borderBottom: 'solid 0.5px silver'
      }
    },
    task: {
      showLabel: true,
      style: {
        borderRadius: 1,
        boxShadow: '2px 2px 4px #888888'
      }
    }
  }
};


function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

const data = [
  {
    "id": 1,
    "start": addDays(new Date(), 3),
    "end": addDays(new Date(), 5),
    "name": "Launch",
    "color": "orange"
  },

  {
    "id": 2,
    "start": addDays(new Date(), 5),
    "end": addDays(new Date(), 8),
    "name": "Feasibility",
    "color": "orange"
  },
  {
    "id": 3,
    "start": addDays(new Date(), 8),
    "end": addDays(new Date(), 12),
    "name": "Prototype",
    "color": "orange"
  },
  {
    "id": 4,
    "start": addDays(new Date(), 12),
    "end": addDays(new Date(), 18),
    "name": "Costing",
    "color": "orange"
  },
  {
    "id": 5,
    "start": addDays(new Date(), 18),
    "end": addDays(new Date(), 20),
    "name": "FEL",
    "color": "orange"
  },
  {
    "id": 6,
    "start": addDays(new Date(), 4),
    "end": addDays(new Date(), 7),
    "name": "RFP",
    "color": "#20BBDA"
  },
  {
    "id": 7,
    "start": addDays(new Date(), 7),
    "end": addDays(new Date(), 11),
    "name": "Bid Evaluation",
    "color": "#20BBDA"
  },
  {
    "id": 8,
    "start": addDays(new Date(), 11),
    "end": addDays(new Date(), 16),
    "name": "Negotation",
    "color": "#20BBDA"
  },
  {
    "id": 9,
    "start": addDays(new Date(), 16),
    "end": addDays(new Date(), 23),
    "name": "Contract Finalization",
    "color": "#20BBDA"
  }

];

class Gantt extends Component {
  constructor(props) {
    super(props);
    //let result = Generator.generateData();
    this.data = data;
    this.state = {
      itemheight: 30,
      data: [],
      selectedItem: null,
      timelineMode: 'month',
      //links: result.links,
      nonEditableName: false
    };
  }
  componentDidMount() {
    /*this.data = data;
    this.setState({
      itemheight: 30,
      data: [],
      selectedItem: null,
      timelineMode: 'month',
      //links: result.links,
      nonEditableName: false
    });*/
  }


  handleDayWidth = (e) => {
    this.setState({ daysWidth: parseInt(e.target.value) });
  };

  handleItemHeight = (e) => {
    this.setState({ itemheight: parseInt(e.target.value) });
  };

  onHorizonChange = (start, end) => {
    let result = this.data.filter((item) => {
      return (item.start < start && item.end > end) || (item.start > start && item.start < end) || (item.end > start && item.end < end);
    });
    console.log('Calculating ');
    this.setState({ data: result });
  };

  onSelectItem = (item) => {
    console.log(`Select Item ${item}`);
    this.setState({ selectedItem: item });
  };

  onUpdateTask = (item, props) => {
    item.start = props.start;
    item.end = props.end;
    this.setState({ data: [...this.state.data] });
    console.log(`Update Item ${item}`);
  };

  onCreateLink = (item) => {
    let newLink = Generator.createLink(item.start, item.end);
    this.setState({ links: [...this.state.links, newLink] });
    console.log(`Update Item ${item}`);
  };

  getbuttonStyle(value) {
    return this.state.timelineMode == value ? { backgroundColor: 'grey', boder: 'solid 1px #223344' } : {};
  }

  modeChange = (value) => {
    this.setState({ timelineMode: value });
  };

  genID() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + '-' + S4() + '-4' + S4().substr(0, 3) + '-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
  }

  getRandomDate() {
    let result = new Date();
    result.setDate(result.getDate() + Math.random() * 10);
    return result;
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  addTask = () => {
    let newTask = {
      id: this.state.data.length + 1,
      start: new Date(),
      end: this.getRandomDate(),
      name: 'New Task',
      color: this.getRandomColor()
    };
    this.setState({ data: [newTask, ...this.state.data] });
  };

  delete = () => {
    console.log('On delete');
    if (this.state.selectedItem) {
      let index = this.state.links.indexOf(this.state.selectedItem);
      if (index > -1) {
        this.state.links.splice(index, 1);
        this.setState({ links: [...this.state.links] });
      }
      index = this.state.data.indexOf(this.state.selectedItem);
      if (index > -1) {
        this.state.data.splice(index, 1);
        this.setState({ data: [...this.state.data] });
      }
    }
  };

  render() {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <DSBox mt={4}>
          <div className="nav-container">
            <div className="mode-container-title">Project Trebleton</div>
            <div className="operation-button-container">
              <div className="operation-button-container" style={{ display: "flex" }}>
                <div className="mode-button" onClick={this.addTask}>
                  <svg height={30} width={30} viewBox="0 0 48 48">
                    <path
                      fill="silver"
                      d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm10 22h-8v8h-4v-8h-8v-4h8v-8h4v8h8v4z"
                    />
                  </svg>
                </div>

              </div>
            </div>

          </div>
          <div className="time-line-container">
            <TimeLine
              config={config}
              data={this.state.data}
              links={this.state.links}
              onHorizonChange={this.onHorizonChange}
              onSelectItem={this.onSelectItem}
              onUpdateTask={this.onUpdateTask}
              onCreateLink={this.onCreateLink}
              mode={this.state.timelineMode}
              itemheight={this.state.itemheight}
              selectedItem={this.state.selectedItem}
              nonEditableName={this.state.nonEditableName}
            />
          </div>
        </DSBox>
      </DashboardLayout>
    );
  }
}


export default Gantt;
